module.exports = __webpack_public_path__ + "img/feature_tradition.993c52e1.png";